import { action } from 'satcheljs';

export default action('POPULATE_PUBLIC_FOLDER_FAVORITE_STORE_V1');
